import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { OperacionService } from "app/services/operaciones/operacion/operacion.service";
import { DesembolsoService } from "app/services/tesoreria/desembolso/desembolso.service";
import { SolicitudDesembolsoService } from "app/services/operaciones/solicitud-desembolso/solicitud-des.service";
import Swal from "sweetalert2";
import { SimuladorService } from "app/services/operaciones/simulador/simulador.service";
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import * as moment from 'moment';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from "@angular/material";
import { environment } from "environments/environment";
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: "app-verificacion-planilla-desembolso",
  templateUrl: "./verificacion-planilla-desembolso.component.html",
  styleUrls: ["./verificacion-planilla-desembolso.component.scss"],
  providers: [DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})

export class VerificacionPlanillaDesembolsoComponent {
  Label_Proformas=environment.LABEL_PROFORMAS;
  Label_Proforma=environment.LABEL_PROFORMA;
  Id_Confirming=environment.ID_CONFIRMING;

  respuesta : boolean;
  ImporteCalculado : number;
  InteresProveedorSum: number;
  formBusqueda: FormGroup;
  formValid: FormGroup;
  loading: boolean;
  resultValidacion: boolean;
  MCalculado: number;
  Adelanto_Importe: number;
  Comision_Importe: number;
  Interes_Importe: number;
  IGV_Importe: number;
  Importe_Planilla_desembolso: number;
  SolidesembolsoDetalle: any = [];
  TComision_ImporteAdq: number;
  TComision_ImporteProv: number;
  TInteres_ImporteAdq: number;
  TInteres_ImporteProv: number;
  TIGV_ImporteAdq: number;
  TIGV_ImporteProv: number;
  adelantoImporteOpe: number;
  desembolso: any = [];
  desembolsoDetalle: any = [];
  ArrdataSolicitudDesembolso: any = [];
  dataSolicitudesDesembolsos: any = [];
  ArrdataOperacion: any = [];
  dataOperacion: any = [];
  newList: any = [];
  Factoring: {
    "VNPP": any,
    "pPAdelanto": any,
    "TEM": any,
    "Plazo": any,
    "Porcentaje_Interes_Adquirente": any
  }
  ArrFactoring: any = [];
  ImporteCalculadoDesembolso: number;
  ArrOperacionDetalle: any = [];

  TAdelanto_Importe: any;
  constructor(
    private desembolsoService: DesembolsoService,
    private solicitudDesembolsoService: SolicitudDesembolsoService,
    private operacionService: OperacionService,
    private simuladorService: SimuladorService
  ) {
    this.formBusqueda = new FormGroup({
      IdPlanilla: new FormControl("", [Validators.required, Validators.min(1), Validators.pattern("^[0-9]+"),]),
    });

    this.formValid = new FormGroup({
      idSolicitudDesembolso: new FormControl({ value: "", disabled: true }),
      idOperacion: new FormControl({ value: "", disabled: true }),
      idProforma: new FormControl({ value: "", disabled: true }),
      Tasa_Mensual: new FormControl({ value: "", disabled: true }),
      Adelanto_Porcentaje: new FormControl({ value: "", disabled: true }),
      VNPP: new FormControl({ value: "", disabled: true }),
      MCalculado: new FormControl({ value: "", disabled: true }),
      Adelanto_Importe: new FormControl({ value: "", disabled: true }),
      Importe_Planilla_desembolso: new FormControl({ value: "", disabled: true }),
      AdelantoAprovado: new FormControl({ value: "", disabled: true }),
      AdelantoSolicitado: new FormControl({ value: "", disabled: true }),
      InteresProveedor: new FormControl({ value: "", disabled: true }),
    });
  }

  getIdPlanilla() {
    return this.formBusqueda.get("IdPlanilla");
  }

  realizarValidacion() {
    this.resetVariables();
    this.obtenerDesembolso();
  }

  resetVariables() {
    // LIMPIO LAS VARIABLES POR CADA CONSULTA
    this.ArrdataSolicitudDesembolso.length = 0;
    this.dataSolicitudesDesembolsos.length = 0;
    this.ArrdataOperacion.length = 0;
    this.dataOperacion.length = 0;
    this.newList.length = 0;
    this.Importe_Planilla_desembolso = 0.00;
    this.Adelanto_Importe = 0.00;
    this.InteresProveedorSum = 0.00;
    this.MCalculado = 0.00;
    this.Comision_Importe = 0.00;
    this.Interes_Importe = 0.00;
    this.IGV_Importe = 0.00;
    this.resultValidacion = null;
    this.loading = null;
    this.ImporteCalculado = 0.00;
    this.TAdelanto_Importe = 0.00;
    this.ImporteCalculadoDesembolso = 0.00;
    this.TComision_ImporteAdq = 0.00;
    this.TComision_ImporteProv = 0.00;
    this.TInteres_ImporteAdq = 0.00;
    this.TInteres_ImporteProv = 0.00;
    this.TIGV_ImporteAdq = 0.00;
    this.TIGV_ImporteProv = 0.00;
    this.desembolsoDetalle = [];
    this.ArrdataSolicitudDesembolso = [];
    this.SolidesembolsoDetalle = [];
    this.ArrdataOperacion = [];
    this.ArrOperacionDetalle  = [];
    this.ArrFactoring = [];
  }

  isParametroCorrecta(valueVar: any, msgError: string) {
    if (valueVar) {
      this.loading = false;
      Swal.fire({
        title: 'Error',
         text: msgError,
          type: 'error',
          heightAuto: false
        });
      console.log("... validación terminada.");
    }
  }
  obtenerDesembolso() {
    this.loading = true; // INICIO LA CARGA AQUÍ POR SER EL PRIMER SERVICIO LLAMADO
    this.desembolsoService.obtenerDesembolsoCab(this.getIdPlanilla().value).subscribe(
      (res) => {
        this.desembolso = res;
        this.isParametroCorrecta(this.desembolso.length == 0, "No existen desembolsos con el Id Planilla especificado");
        if(this.desembolso.length != 0){
          this.Importe_Planilla_desembolso = parseFloat(this.desembolso[0]['Importe']); // GUARDAR MONTO DE PLANILLA
          this.obtenerDesembolsoDet();
        }  
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  obtenerDesembolsoDet() {
    this.loading = true;
    this.desembolsoService.obtenerDesembolsoDet(this.getIdPlanilla().value).subscribe(
      (res) => {
        this.desembolsoDetalle = res;
        for (const elemento of this.desembolsoDetalle) {
          this.isParametroCorrecta(elemento.idSolicitudDesembolso == null, "No existen solicitud desembolso con el Id Solicitud Desembolso especificado.");
          this.solicitudDesembolsoService.ObtenerDesembolsoPorId(elemento.idSolicitudDesembolso).subscribe(
            (resp) => {
              this.ArrdataSolicitudDesembolso = resp;
              this.dataSolicitudesDesembolsos = resp;
               let arrayNuevo: any = [];
                let a = this.newList.filter((object) => object.idSolicitudDesembolso == this.dataSolicitudesDesembolsos.idSolicitudDesembolso); // INICIO DE FILTRO DE OBJETOS REPETIDOS
                if (a.length === 0) {
                  arrayNuevo = this.dataSolicitudesDesembolsos;
                  arrayNuevo.ImporteAnexo = elemento.ImporteAnexo;
                  
                  this.solicitudDesembolsoService.ObtenerTotalImporteSunat(elemento.idSolicitudDesembolso).subscribe(
                    (respu) => {
                      const elementoSD: any = respu;
                        arrayNuevo.InteresProveedorSum = elementoSD.InteresProveedorSum;
                        this.operacionService.ObtenerOperacionPorId(this.dataSolicitudesDesembolsos.idOperacion).subscribe(
                          (respuest) => {
                            const eC: any = respuest;
                              this.adelantoImporteOpe = eC.VNPP * eC.Adelanto_porcentaje
                              arrayNuevo.Adelanto_Importe_Ope = this.adelantoImporteOpe;
                                  eC.Detail.forEach(elementOpeDetalle => {
                                    var fFecha_Desembolso = moment(eC.Fecha_Desembolso);
                                    var fFecha_de_Pago = moment(elementOpeDetalle.Fecha_de_Pago);
                                    var Plazo = fFecha_de_Pago.diff(fFecha_Desembolso, 'days');
                                    var PorcentajeAdq = eC.Porcentaje_Interes_Adquirente;
                                    this.Factoring = {
                                      "VNPP": this.dataSolicitudesDesembolsos.VNPP,
                                      "pPAdelanto": eC.Adelanto_porcentaje,
                                      "TEM": eC.Tasa_Mensual,
                                      "Plazo": Plazo,
                                      "Porcentaje_Interes_Adquirente": PorcentajeAdq
                                    };

                                    this.simuladorService.factoring(this.Factoring).subscribe(
                                      rpt => {
                                        this.ArrFactoring.push(rpt);                                                                                                                                                           
                                        for(let eF of this.ArrFactoring){  
                                          this.ImporteCalculado = 0;                                     
                                          if(eC.Tipo_Servicio == this.Id_Confirming){
                                            this.ImporteCalculado += Number(eF.DesembolsoProvConfirming);
                                          } else{
                                            this.ImporteCalculado += Number(eF.Desembolso);
                                          } 
                                                                              
                                        }                                    
                                        arrayNuevo.ImporteCalculado = this.ImporteCalculado                                    
                                        this.compararMontos(arrayNuevo.ImporteCalculado,arrayNuevo.Desembolso_Importe,arrayNuevo.ImporteAnexo); 
                                        arrayNuevo.resultValidacion = this.resultValidacion// COMPARACIÓN DE MONTO CONTRATO, MONTO PLANILLA Y MONTO CALCULADO                                                                       
                                        this.loading = false;  
                                      }, err => {
                                        this.loading = false;
                                      }
                                    )
                                    
                                  });
                          },
                          (err) => {
                            this.loading = false;
                          }
                        );
                    },
                    (err) => {
                      this.loading = false;
                    }
                  );                  
                }                
              this.newList.push(arrayNuevo);
            },
            (err) => {
              this.loading = false;
            }
          );        
        }    
      },            
      (err) => {
        this.loading = false;
      }      
    );
  }

  compararMontos(Importecalc:any, Desembolso_Importe:any,ImporteAnexo:any) {
    if (Importecalc != Desembolso_Importe && Importecalc != ImporteAnexo) {
      this.resultValidacion = false;
    }else {
      this.resultValidacion = true;
    }    
  }
}